import { z } from "zod";
import { schemes } from "../../schema-validation";

export const transactionsFilterQuerySchema = z.object({
  amount: z.string().optional(),
  amountFrom: z.string().optional(),
  amountTo: z.string().optional(),
  correlationID: schemes.uuid().optional(),
  date: z.string().optional(),
  dateFrom: z.string().optional(),
  dateTo: z.string().optional(),
  destination: z.string().optional(),
  destination_worker: z.string().optional(),
  employeeID: z.string().optional(),
  contractorID: z.string().optional(),
  connectionID: z.string().optional(),
  q: z.string().optional(),
  retry: z.enum(["false"]).optional(),
  sortDirection: z.enum(["asc", "desc"]).optional(),
  sortBy: z.string().optional(),
  source: z.string().optional(),
  source_worker: z.string().optional(),
  start_at: z.string().optional(),
  status: z.string().optional(),
  transaction_type: z.string().optional(),
  transactionID: z.string().optional(),
  transfer_type: z.string().optional(),
});

export type TransactionsFilterQuerySchema = z.infer<
  typeof transactionsFilterQuerySchema
>;
